<template>
	<el-card
		shadow="hover"
		:class="['card-cliente', estadoClass, { Pendiente: esPendiente, completado: estado_realizado === 'completado' }]"
		:key="`cliente-${estado_realizado}-${cliente.generalId}`"
	>
		<el-select
			v-model="estadoSeleccionado"
			v-if="estado_realizado === 'Pendiente'"
			placeholder="Estado"
			size="small"
			@change="cambiarEstado"
			class="select"
			@blur="cerrarSelect"
			:teleported="true"
		>
			<el-option label="Normal" value="normal" />
			<el-option label="Pendiente" value="pendiente" />
			<el-option label="No visitado" value="no_fuimos" />
		</el-select>

		<!-- Info del cliente -->
		<div @click="irADetalleCliente(cliente)" style="cursor: pointer;">
			<div class="card-text">
				<strong>{{ cliente.nombre }}</strong>
			</div>
			<div class="card-text">{{ cliente.direccion }}</div>
			<div class="card-text" v-if="mostrarHora">Hora: {{ cliente.hora || 'No asignada' }}hs</div>
			<div v-if="mostrarEstado && cliente.estado !== 'normal' && estado_realizado !== 'completado'">
				<div class="card-text">Estado: {{ estadoLabel }}</div>
			</div>
		</div>
	</el-card>
</template>
<script>
export default {
	name: 'ClienteCard',
	props: {
		cliente: { type: Object, required: true },
		estado_realizado: { type: String, default: '' },
		mostrarHora: { type: Boolean, default: true },
		esPendiente: { type: Boolean, default: false },
		irADetalleCliente: { type: Function, required: true },
		mostrarEstado: { type: Boolean, default: true },
	},
	data() {
		return {
			mostrandoSelect: false,
			estadoSeleccionado: '',
		};
	},
	computed: {
		estadoClass() {
			switch (this.cliente.estado) {
				case 'pendiente':
					return 'estado-pendiente';
				case 'no_fuimos':
					return 'estado-no-fuimos';
				case 'normal':
				default:
					return 'estado-normal';
			}
		},
		estadoLabel() {
			const labels = {
				pendiente: 'Pendiente',
				no_fuimos: 'No visitado',
				normal: 'Normal',
			};
			return labels[this.cliente.estado] || this.cliente.estado;
		},
	},
	methods: {
		mostrarSelect() {
			this.mostrandoSelect = true;
			this.estadoSeleccionado = '';
		},
		cerrarSelect() {
			setTimeout(() => {
				this.mostrandoSelect = false;
			}, 200);
		},
		cambiarEstado(nuevoEstado) {
			this.$emit('cambiarEstado', this.cliente.generalId, nuevoEstado);
			this.mostrandoSelect = false;
		},
	},
};
</script>
<style scoped>
.estado-normal {
	background-color: white;
	border: 1px solid #dcdfe6;
	color: black;
}
.estado-pendiente {
	background-color: #f56c6c; /* rojo */
	border: 2px solid #f56c6c;
	color: white;
}
.estado-no-fuimos {
	background-color: #e6a23c; /* naranja */
	border: 2px solid #e6a23c;
	color: white;
}
.card-cliente {
	border-radius: 5px;
	margin: 1px 5px;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
	margin-top: 5px;
}
.completado {
	border: solid #67c23a 1px;
	background-color: #67c23a;
	margin: 5px;
	color: white;
}
.card-text {
	font-size: medium;
	padding: 1px 3px;
}
.select {
	position: absolute;
	bottom: 10px;
	right: 10px;
	width: 120px;
	overflow: visible !important;
}
</style>
